import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { Transaction } from 'frontend-payments/models';
import { TRANSACTION_STATUS } from 'frontend-payments/models/transaction';
import type { Model } from 'frontend-payments/routes/authenticated/overview';

export default class AuthenticatedOverviewController extends Controller {
  declare model: Model;

  @service declare router: Services['router'];

  @tracked isStatementOfAccountModalOpen = false;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get account() {
    if (this.isAccountRequestLoading) {
      return null;
    }
    return this.model.account?.value;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isAccountRequestLoading() {
    return this.model.account?.isRunning ?? false;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isTransactionRequestLoading() {
    return this.model.transactionsRequest?.isRunning ?? false;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get transactions() {
    if (this.isTransactionRequestLoading) {
      return [];
    }

    return this.model.transactionsRequest?.value?.transactions ?? [];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get unpaidTransactions() {
    return this.transactions.filter(
      (transaction) =>
        transaction.status === TRANSACTION_STATUS.UNPAID ||
        transaction.status === TRANSACTION_STATUS.OVERDUE,
    );
  }

  @action
  closeStatementOfAccountModal(): void {
    this.isStatementOfAccountModalOpen = false;
  }

  @action
  openStatementOfAccountModal(): void {
    this.isStatementOfAccountModalOpen = true;
  }

  @action
  selectPaymentMethodForTransaction(transaction: Transaction): void {
    this.router.transitionTo('authenticated.payment-method', {
      queryParams: {
        transactionIds: transaction.id,
      },
    });
  }
}
